import React, { useCallback, FC, Dispatch } from 'react';
import { DialogContent, FormControlLabel } from '@material-ui/core';
import { SaveSurvey } from 'src/modules/shared/slices/survey/surveyApi';
import { useRequestMeMutation } from 'src/modules/shared/slices/auth/entity/api/auth';
import { StyledDivider, StyledRadio, StyledRadioGroup } from './styled';
import { answerInitialValue, questionsType } from '../constants';

const SurveyFormContent: FC<{
  form: SaveSurvey[];
  setForm: Dispatch<React.SetStateAction<SaveSurvey[]>>;
}> = ({ form, setForm }) => {
  const [, { data: meResponse }] = useRequestMeMutation({
    fixedCacheKey: '/me',
  });

  const handleClick = useCallback(
    (key: string, value: number | string) => {
      const questionIndex = form.findIndex((item) => item.key === key);
      if (!questionIndex && questionIndex !== 0) return;
      const newForm = [...form];
      const questionType =
        newForm[questionIndex].type === 'multi-choice' ? 'multiChoiceAnswer' : 'answer';

      newForm[questionIndex] = { ...newForm[questionIndex], [questionType]: value };

      setForm(newForm);
    },
    [form, setForm]
  );

  const getValue = useCallback(
    (index: number) => {
      let initialValue: number | string = answerInitialValue;
      if (!index && index !== 0) return initialValue;
      if (form[index].answer || form[index].answer === 0) {
        initialValue = form[index].answer;
      } else if (
        form[index].multiChoiceAnswer &&
        form[index].multiChoiceAnswer !== answerInitialValue.toString()
      ) {
        initialValue = form[index].multiChoiceAnswer;
      }

      return initialValue;
    },
    [form]
  );

  if (!meResponse?.survey) return null;

  const { questions } = meResponse.survey;

  return (
    <>
      <DialogContent style={{ gap: 4, display: 'flex', flexDirection: 'column' }}>
        {questions.length &&
          questions?.map((item, index) => {
            return (
              <div key={item.key}>
                <>
                  <div dangerouslySetInnerHTML={{ __html: item.question }} />
                  <StyledRadioGroup
                    name="radio-buttons-group"
                    value={getValue(index)}
                    row={item.type !== 'multi-choice'}
                  >
                    {item.type === 'rating' && (
                      <div
                        style={{ width: '64px', textAlign: 'center', overflowWrap: 'break-word' }}
                      >
                        onwaar-schijnlijk
                      </div>
                    )}

                    {item.type === 'multi-choice' &&
                      item.options?.length &&
                      item?.options?.map((optionItem) => {
                        return (
                          <FormControlLabel
                            key={optionItem.value}
                            onClick={() => handleClick(item.key, optionItem.value)}
                            value={optionItem.value}
                            labelPlacement={'end'}
                            style={{ margin: 0, alignItems: 'center', whiteSpace: 'nowrap' }}
                            control={
                              <StyledRadio
                                id={optionItem.label}
                                size="small"
                                style={{ alignItems: 'center' }}
                              />
                            }
                            label={optionItem.label}
                          />
                        );
                      })}
                    {item.type !== 'multi-choice' &&
                      questionsType[item.type].length &&
                      questionsType[item.type]?.map((radioItem) => {
                        return (
                          <FormControlLabel
                            key={radioItem.answer}
                            onClick={() => handleClick(item.key, radioItem.answer)}
                            value={radioItem.answer}
                            labelPlacement="bottom"
                            style={{ width: 'min-content', margin: 0, alignItems: 'center' }}
                            control={
                              <StyledRadio
                                id={radioItem.label}
                                size="small"
                                style={{ alignItems: 'center' }}
                              />
                            }
                            label={radioItem.label}
                          />
                        );
                      })}
                    {item.type === 'rating' && (
                      <div
                        style={{ width: '64px', textAlign: 'center', overflowWrap: 'break-word' }}
                      >
                        zeer waar-schijnlijk
                      </div>
                    )}
                  </StyledRadioGroup>
                </>
                {index < questions.length - 1 && <StyledDivider />}
              </div>
            );
          })}
      </DialogContent>
    </>
  );
};

export default SurveyFormContent;
